
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M20.5 13H22V16H20.5V13ZM18 13H19.5V16H18V13ZM17 14.5C17 13.67 16.33 13 15.5 13H14.66L16.84 15.18C16.94 14.97 17 14.74 17 14.5ZM18.96 2.34997H19H18.96ZM18.85 4.72997C19.23 4.34997 19.52 3.88997 19.69 3.37997C19.85 2.87997 19.5 2.36997 18.98 2.35997C18.64 2.36997 18.37 2.60997 18.26 2.93997C18.08 3.48997 17.64 3.92997 17.09 4.10997C16.75 4.21997 16.5 4.49997 16.5 4.84997V4.99997C16.5 5.36997 16.77 5.68997 17.14 5.74997C19.07 6.05997 20.5 7.74997 20.5 9.76997V11.25C20.5 11.66 20.84 12 21.25 12C21.66 12 22 11.66 22 11.25V9.75997C22 7.53997 20.72 5.61997 18.85 4.72997ZM14.61 8.64997H16.03C17.08 8.64997 18 9.38997 18 10.7V11.25C18 11.66 18.33 12 18.75 12H18.76C19.17 12 19.51 11.67 19.51 11.25V10.36C19.51 8.54997 17.91 7.19997 16.04 7.19997H14.74C13.72 7.19997 12.8 6.46997 12.67 5.44997C12.55 4.49997 13.13 3.74997 13.97 3.51997C14.29 3.42997 14.51 3.13997 14.51 2.79997C14.51 2.30997 14.05 1.93997 13.58 2.07997C12.16 2.48997 11.13 3.80997 11.16 5.35997C11.18 7.20997 12.77 8.64997 14.61 8.64997ZM4.12 5.28997C3.73 4.89997 3.1 4.89997 2.71 5.28997C2.32 5.67997 2.32 6.30997 2.71 6.69997L9 13H3.5C2.67 13 2 13.67 2 14.5C2 15.33 2.67 16 3.5 16H12L18.29 22.29C18.68 22.68 19.31 22.68 19.7 22.29C20.09 21.9 20.09 21.27 19.7 20.88L4.12 5.28997Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-smoke-free`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSmokeFree

    ```js
    <b-new-b-icon-smoke-free />
    ```
</docs>


